import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from 'react-bootstrap/Placeholder';
function LoadingTasks(props) {  
  return(
    <Tabs
				
				activeKey="PERSONAL"
			
				id="fill-tab-example"
				className="mb-3"
				justify
				fill
			>
    <Tab eventKey="PERSONAL" title="Personal">
  <Accordion  flush>
  
  <Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
<Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
<Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
<Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
<Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
<Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
<Accordion.Item eventKey="0">
  <Accordion.Header>
			<Container>
			<Row sm={1} md={2}>
			<Col >
      <Placeholder xs={8} />
      </Col>
      
      </Row>
      </Container>
      </Accordion.Header>
</Accordion.Item>
  </Accordion>
  
  </Tab>
  <Tab eventKey="WORK" title="Work">

  </Tab>
  </Tabs>
  )
}

export default LoadingTasks;